@if(!isProd){
  <section>
    <div [ngClass]="{'aviso-hml': !isMobile, 'aviso-hml-mobile': isMobile}" role="button" tabindex="0" (click)="mostrarDetalhesPlataforma()" (keydown.enter)="mostrarDetalhesPlataforma()">
      {{ avisoTexto }}
    </div>
  </section>
}

@if (estaLogado) {
  <app-lembrete-notificacao [mobile]="isMobile" />
}

<mat-sidenav-container
  class="main-container"
  [autosize]="true"
  [style]="!isProd ? 'margin-top: 15px; height: calc(100vh - 15px)' : ''"
  [style.margin-top]="!isProd && !isMobile && estaLogado ? '16px' : '0px'"
  [style.height]="calcularHeightPagina()"
  [style.padding-bottom]="isMobile && estaLogado && !contatoSelecionado && designAntigo ? 'calc(60px + env(safe-area-inset-bottom, 0px))' : '0px'">

  @if(!isMobile){
    <mat-sidenav style="margin: 10px; border-radius: 10px;" disableClose mode="side" [fixedInViewport]="false" [opened]="estaLogado">
      @if (estaLogado) {
        <app-side-menu [isMobile]="false" (menuOpenChange)="onMenuOpenChange($event)"></app-side-menu>
      }
    </mat-sidenav>
  }

  <mat-sidenav-content class="content-area">
    <div class="pagina">
      @if (titulo && titulo.length > 0 && designAntigo) {
        <div class="titulo-area">
          <app-titulo class="width-100" [titulo]="titulo" [idRotina]="idRotina"></app-titulo>
        </div>
      }

      <div class="conteudo-area">
        <router-outlet></router-outlet>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>

@if(isMobile && estaLogado && !contatoSelecionado && designAntigo) {
  <mat-toolbar class="tool-bar" color="primary">
    <app-side-menu [openMenu]="isMenuOpen" [isMobile]="true" (menuOpenChange)="onMenuOpenChange($event)"></app-side-menu>
  </mat-toolbar>
}

@if (notificacoesTransferencia.length > 0) {
  <div class="transferencia-toast-container">
    @for (notificacao of notificacoesTransferencia; track notificacao.id) {
      <div class="transferencia-toast" @toastAnimation role="button" tabindex="0" (click)="removerNotificacaoTransferencia(notificacao.id)" (keydown.enter)="removerNotificacaoTransferencia(notificacao.id)" (mouseenter)="pausarTimerNotificacao(notificacao.id)" (mouseleave)="retomarTimerNotificacao(notificacao.id)">
        <div class="transferencia-toast-borda"></div>
        <div class="transferencia-toast-align">
          <img src="./../assets/icones/icone-msg-nao-lida.svg" alt="">
          <div class="transferencia-toast-conteudo">
            <p class="transferencia-toast-titulo">Um novo contato disponivel</p>
            <p class="transferencia-toast-texto">Um atendimento foi redirecionado para sua fila</p>
            <a href="" (click)="irParaConversa(notificacao, $event)">Ir para conversa</a>
          </div>
        </div>
      </div>
    }
  </div>
}
